import * as React from 'react';
import SlickSlider from 'react-slick';

import { StatisticsPageLocale } from '../../../components/StatisticsPage/statisticsPage.locale';
import { Query } from '../../../GraphQL';
import SliderComponent from '../../../components/StatisticsPage/Slider/Slider';

interface SliderProps {
  locale: StatisticsPageLocale;
  traffics: Query['traffics'][];
  setActiveGraph: (index: number) => void;
  sliderRef: React.RefObject<SlickSlider>;
  loading: boolean;
}

interface SliderState {
  hydrated: boolean;
}

class Slider extends React.Component<SliderProps, SliderState> {
  state = {
    hydrated: false,
  };

  componentDidMount() {
    this.setState({ hydrated: true });
  }

  shouldComponentUpdate(nextProps: SliderProps, nextState: SliderState) {
    return this.props.loading !== nextProps.loading || this.state.hydrated !== nextState.hydrated;
  }

  render() {
    return <SliderComponent {...this.props} hydrated={this.state.hydrated} />;
  }
}

export default Slider;



// WEBPACK FOOTER //
// /www/client/src/containers/StatisticsPage/Slider/Slider.tsx